import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, CardBody, Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import { BrowserView, MobileView, isTablet } from 'react-device-detect';
import moment from 'moment';
import ReportImage from './ReportImage';
import DamagesList from './DamagesList';
import Translate, { t, translateDate, numStr } from '../common/Translate';
import ImageGalery from './ImageGallery';
import { getAllGalleryPictures, orderGalleryPictures } from '../../Utils/gallery';

const calculatePussance = (kw, ps) => {
  if (kw && ps === 0) return Math.round(1.36 * kw);
  if (ps && kw === 0) return Math.round(ps / 1.36);
  return null;
};

function filterContent(section, content, isDE = false) {
  if (section === 'vehicle') {
    const vehicleContent = [
      'bodyLabel',
      'firstHand',
      'fuelLabel',
      'gearBoxLabel',
      'imported',
      'liter',
      'registrationDate',
      'gcDate',
      'color',
      'inside_color',
      'vehicule_paint_metal',
      'vehicule_test_mileage',
      'vehicule_type',
      'username',
      'firstname',
      'lastname',
      'email',
      'version',
    ];

    if (isDE) {
      vehicleContent.unshift('vin');
    }
    const filteredContent = {};
    vehicleContent.forEach((key) => {
      filteredContent[key] = _.get(content, key, ['string', null]);
    });
    let kw = _.get(content, 'kw.1', null);
    let ps = _.get(content, 'ps.1', null);
    if (kw !== null && ps !== null) {
      if (kw && ps === 0) ps = calculatePussance(kw, ps);
      if (kw === 0 && ps) kw = calculatePussance(kw, ps);
      if (kw !== 0 && ps !== 0) filteredContent[t('power')] = ['string', `${kw} KW (${ps} PS)`]; // ticket 45547 - Leistung: 110 kW (150 PS)
    }
    return filteredContent;
  }
  if (section === 'wheels') {
    let useMirror = false;
    let tire_depth = '';
    const wheels_tire_depth = [
      'wheels_front_left_tire_depth',
      'wheels_back_left_tire_depth',
      'wheels_front_right_tire_depth',
      'wheels_back_right_tire_depth',
    ];

    const wheels_pictures_multiple = [
      'wheels_front_tire_invoice_picture',
      'wheels_front_brakes_invoice_picture',
      'wheels_back_tire_invoice_picture',
      'wheels_back_brakes_invoice_picture',
    ];
    wheels_tire_depth.forEach((key) => {
      const res = _.get(content, key, ['string', 'info_indispo']);
      if (res[1] !== '') tire_depth = res;
    });

    const filteredContent = {};

    if (Object.prototype.hasOwnProperty.call(content, 'approved_tires')) {
      filteredContent.approved_tires = [_.get(content, 'approved_tires', ['string', 'info_indispo'])];
    }

    if (Object.prototype.hasOwnProperty.call(content, 'wheels_drum_brake')) {
      filteredContent.wheels_drum_brake = [_.get(content, 'wheels_drum_brake', ['string', 'info_indispo'])];
    }

    if (Object.prototype.hasOwnProperty.call(content, 'wheels_back_tire_type')) {
      useMirror = true;
      filteredContent.saison = [
        _.get(content, 'wheels_back_tire_type', ['string', 'info_indispo']),
        _.get(content, 'wheels_back_tire_type', ['string', 'info_indispo']),
      ];
    }
    if (
      Object.prototype.hasOwnProperty.call(content, 'wheels_front_rim_type') &&
      Object.prototype.hasOwnProperty.call(content, 'wheels_back_rim_type')
    ) {
      useMirror = true;
      filteredContent.rim_type = [
        _.get(content, 'wheels_front_rim_type', ['select', 'info_indispo']),
        _.get(content, 'wheels_back_rim_type', ['select', 'info_indispo']),
      ];
    }

    if (
      Object.prototype.hasOwnProperty.call(content, 'wheels_front_age') &&
      Object.prototype.hasOwnProperty.call(content, 'wheels_back_age')
    ) {
      useMirror = true;
      filteredContent.construction_year = [
        _.get(content, 'wheels_front_age', ['integer', 'info_indispo']),
        _.get(content, 'wheels_back_age', ['integer', 'info_indispo']),
      ];
    }

    if (
      Object.prototype.hasOwnProperty.call(content, 'wheels_front_dimensions') &&
      Object.prototype.hasOwnProperty.call(content, 'wheels_back_dimensions')
    ) {
      useMirror = true;
      filteredContent.dimensions = [
        _.get(content, 'wheels_front_dimensions', ['rim_size', 'info_indispo']),
        _.get(content, 'wheels_back_dimensions', ['rim_size', 'info_indispo']),
      ];
    }

    if (
      Object.prototype.hasOwnProperty.call(content, 'wheels_front_tire_brand') &&
      Object.prototype.hasOwnProperty.call(content, 'wheels_back_tire_brand')
    ) {
      useMirror = true;
      filteredContent.tire_brand = [
        _.get(content, 'wheels_front_tire_brand', ['select', 'info_indispo']),
        _.get(content, 'wheels_back_tire_brand', ['select', 'info_indispo']),
      ];
    }

    if (tire_depth[1] !== 'info_indispo') {
      useMirror = true;
      filteredContent.tire_depth_left = [tire_depth, tire_depth];
    }

    if (
      Object.prototype.hasOwnProperty.call(content, 'wheels_front_left_picture') &&
      Object.prototype.hasOwnProperty.call(content, 'wheels_front_right_picture')
    ) {
      useMirror = true;
      filteredContent.tire_front_picture = [
        _.get(content, 'wheels_front_left_picture', ['image', null]),
        _.get(content, 'wheels_front_right_picture', ['image', null]),
      ];
    }

    if (tire_depth[1] !== 'info_indispo') {
      useMirror = true;
      filteredContent.tire_depth_right = [tire_depth, tire_depth];
    }

    if (
      Object.prototype.hasOwnProperty.call(content, 'wheels_back_left_picture') &&
      Object.prototype.hasOwnProperty.call(content, 'wheels_back_right_picture')
    ) {
      useMirror = true;
      filteredContent.tire_back_picture = [
        _.get(content, 'wheels_back_left_picture', ['image', null]),
        _.get(content, 'wheels_back_right_picture', ['image', null]),
      ];
    }
    wheels_pictures_multiple.forEach((el) => {
      const result = _.filter(content, (value, key) => key.includes(el));
      if (result.length > 0) {
        filteredContent[`${el}_multiple`] = result;
      }
    });

    if (Object.prototype.hasOwnProperty.call(content, 'wheels_front_tire_depth_picture'))
      filteredContent.tire_front_depth_picture = [_.get(content, 'wheels_front_tire_depth_picture', ['image', null])];
    if (Object.prototype.hasOwnProperty.call(content, 'wheels_back_tire_depth_picture'))
      filteredContent.tire_back_depth_picture = [_.get(content, 'wheels_back_tire_depth_picture', ['image', null])];

    filteredContent.damages = content.damages;
    filteredContent.useMirror = useMirror;

    return filteredContent;
  }
  return null;
}

const ReportElement = (props) => {
  const [collapse, setCollapse] = useState(false);
  let total = null;
  const { section, referential, formId, configType, isDE, symbol, refHexaId, report, country, expertiseEndDate } =
    props;
  let { content } = props;
  let block = null;
  const toggle = () => setCollapse(!collapse);

  if (content === null || content === undefined) return null;

  if (section === 'vehicle') content = filterContent(section, content, isDE);
  if (section === 'vehicle_pictures') {
    const vehiclePictures = orderGalleryPictures(content);
    const allPictures = getAllGalleryPictures(report);
    if (vehiclePictures.length > 0) {
      return (
        <Row>
          <Col>
            <ImageGalery
              images={vehiclePictures}
              formId={formId}
              hideLabel={false}
              refHexaId={refHexaId}
              allPictures={allPictures}
            />
          </Col>
        </Row>
      );
    }
  }
  if (section === 'servicing') {
    if (content.last_servicing_km !== undefined && content.last_servicing_km[1] > 0) {
      content.last_servicing_km[1] = numStr(content.last_servicing_km[1]);
    }
  }

  block = Object.entries(content).map(([key, value]) => {
    if (key === 'damages') {
      return (
        <DamagesList
          country={country}
          key={key}
          damages={value}
          referential={referential}
          formId={formId}
          section={section}
          symbol={symbol}
        />
      );
    }
    if (key === 'totals') {
      total = value[referential];
      if (total === undefined) total = null;
      return null;
    }

    if (value[0] === 'image') {
      return (
        <Row key={key}>
          <Col xs="6" sm="4" md="3" lg="2">
            <div className="vehicule-pictures-container">
              <ReportImage key={key} imageId={value[1]} name={key} formId={formId} allImages={[]} />
            </div>
          </Col>
        </Row>
      );
    }
    if ([null, ''].includes(value[1])) return null;
    return (
      <Row key={key}>
        <Col xs="6" lg="3">
          <p className="report-element-label">
            <Translate code={key} />
          </p>
        </Col>
        <Col xs="6" lg="3">
          <ValueRender value={value} id={key} />
        </Col>
      </Row>
    );
  });

  if (section === 'expertise') {
    const variables = {};
    const { buyerName, placeExpertise } = content;
    variables.dateExp = moment(expertiseEndDate).format('DD-MM-YYYY');
    variables.hourExp = moment(expertiseEndDate).format('HH');
    variables.minExp = moment(expertiseEndDate).format('mm');
    variables.buyerName = buyerName && buyerName[1];
    variables.placeExp = placeExpertise && placeExpertise[1];

    block = (
      <div>
        <Row>
          <Col>
            <Translate code="expertise_info" {...variables} />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs="6" lg="3">
            <p className="report-element-label">
              <Translate code="exp_duration" />
            </p>
          </Col>
          <Col xs="6" lg="3">
            <ValueRender value={content.durationExpertise} />
          </Col>
        </Row>
        {configType?.[1] && (
          <Row>
            <Col xs="6" lg="3">
              <p className="report-element-label">
                <Translate code="configType" />
              </p>
            </Col>
            <Col xs="6" lg="3">
              <ValueRender value={configType} />
            </Col>
          </Row>
        )}
      </div>
    );
  }

  if (section === 'wheels') {
    content = filterContent(section, content);
    const { useMirror } = content;
    delete content.useMirror;
    block = (
      <>
        <table className="report-table-wheels">
          {useMirror && (
            <thead>
              <tr>
                <td>
                  <p />
                </td>
                <td>
                  <p className="report-element-value text-center">
                    <font color="#818099">
                      <Translate code="AVANT" />
                    </font>
                  </p>
                </td>
                <td>
                  <p className="report-element-value text-center">
                    <font color="#818099">
                      <Translate code="ARRIERE" />
                    </font>
                  </p>
                </td>
              </tr>
            </thead>
          )}

          <tbody>
            {Object.entries(content).map(([key, value]) => {
              if (key === 'damages' || key.endsWith('_picture') || key.endsWith('_multiple')) return null;
              if (key === 'tire_depth_left') {
                return (
                  <>
                    <tr>
                      <td>
                        <p className="report-element-value">
                          <Translate code="EPAISSEUR" />
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Translate code={key} />
                      </td>
                      <td className="text-center">
                        {(value[0] === '' && <p className="report-element-value">{t('info_indispo')}</p>) || (
                          <ValueRender value={value[0]} />
                        )}
                      </td>
                      <td className="text-center">
                        {(value[1] === '' && <p className="report-element-value">{t('info_indispo')}</p>) || (
                          <ValueRender value={value[1]} />
                        )}
                      </td>
                    </tr>
                  </>
                );
              }
              if (key === 'approved_tires' || key === 'wheels_drum_brake') {
                return (
                  <>
                    <tr>
                      <td>
                        <p>
                          <Translate code={key} />
                        </p>
                      </td>
                      <td>{value[0][1] && <p className="report-element-value float-right">{t(value[0][1])}</p>}</td>
                    </tr>
                  </>
                );
              }
              return (
                <tr>
                  <td>
                    <Translate code={key} />
                    {key === 'dimemsions' && ' (mm)'}
                  </td>
                  <td className="text-center">
                    {(value[0][1] === '' && <p className="report-element-value">{t('info_indispo')}</p>) || (
                      <ValueRender value={value[0]} />
                    )}
                  </td>
                  <td className="text-center">
                    {(value[1][1] === '' && <p className="report-element-value">{t('info_indispo')}</p>) || (
                      <ValueRender value={value[1]} />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {Object.entries(content).map(([key, value]) => {
          if (key.endsWith('_picture')) {
            return (
              <Row key={key}>
                <Col xs="6" sm="6" md="4" lg="3">
                  <div className="vehicule-pictures-container">
                    <ReportImage key={key} imageId={value[0][1]} name={key} formId={formId} allImages={[]} />
                  </div>
                </Col>
                {value[1]?.[1] && (
                  <Col xs="6" sm="6" md="4" lg="3">
                    <div className="vehicule-pictures-container">
                      <ReportImage key={key} imageId={value[1][1]} name="" formId={formId} allImages={[]} />
                    </div>
                  </Col>
                )}
              </Row>
            );
          }
          if (key === 'damages') {
            return (
              <DamagesList
                country={country}
                key={key}
                damages={value}
                referential={referential}
                formId={formId}
                section={section}
                symbol={symbol}
              />
            );
          }
          if (key.endsWith('_multiple')) {
            return (
              <Row key={key}>
                {value.map((v) => (
                  <Col xs="6" sm="6" md="4" lg="3">
                    <div className="vehicule-pictures-container">
                      <ReportImage key={v} imageId={v[1]} name="" formId={formId} allImages={[]} />
                    </div>
                  </Col>
                ))}

                <p className="report-element-label w-100">
                  <font color="#273c78">
                    <Translate code={key.replace('_multiple', '')} />
                  </font>
                </p>
              </Row>
            );
          }
          return null;
        })}
      </>
    );
  }

  return (
    <>
      <MobileView>
        <Card className={collapse ? 'card-open' : 'card-close'}>
          <CardBody>
            <div onClick={toggle} onKeyDown={() => {}} role="presentation">
              <div className="card-title" data-cy={section}>
                <Translate code={section} />
                <span className="card-title-price" data-cy={`${section}_cost`}>
                  {total !== null && ` ${total}  ${t(symbol)}`}
                </span>

                {(collapse && <FontAwesomeIcon icon={faChevronUp} />) || <FontAwesomeIcon icon={faChevronDown} />}
              </div>
            </div>
            <Collapse className="card-element" isOpen={collapse}>
              {block}
            </Collapse>
          </CardBody>
        </Card>
      </MobileView>
      {!isTablet && <BrowserView>{block}</BrowserView>}
    </>
  );
};

ReportElement.propTypes = {
  section: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  referential: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  content: PropTypes.shape().isRequired,
  configType: PropTypes.instanceOf(Array).isRequired,
  isDE: PropTypes.bool.isRequired,
  symbol: PropTypes.string.isRequired,
  refHexaId: PropTypes.string.isRequired,
  report: PropTypes.shape().isRequired,
  expertiseEndDate: PropTypes.string.isRequired,
};

export default ReportElement;

const ValueRender = ({ value, id = '' }) => {
  switch (value[0]) {
    case 'select_multiple':
      return (
        <p className="report-element-value">
          {value[1].map((element) => (
            <React.Fragment key={element}>
              <Translate code={element} />
              <br />
            </React.Fragment>
          ))}
        </p>
      );
    case 'rim_size':
      return (
        <p className="report-element-value">
          {value[1].width}/{value[1].height} R{value[1].diameter}
        </p>
      );
    case 'date':
      return <p className="report-element-value">{translateDate(value[1], 'DD.MM.YYYY')}</p>;
    case 'boolean':
      return (
        <p className="report-element-value">
          <Translate code={value[1] ? 'True' : 'False'} />
        </p>
      );
    case 'int':
    case 'integer':
    case 'number':
      if (id !== '') {
        return <p className="report-element-value">{id === 'client_zip' ? value[1] : numStr(value[1])}</p>;
      }
      return <p className="report-element-value">{value[1]}</p>;
    default:
      return (
        <p className="report-element-value">
          <Translate code={value[1]} />
        </p>
      );
  }
};

ValueRender.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array]).isRequired,
  id: PropTypes.string,
};

ValueRender.defaultProps = {
  id: '',
};
